import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import App from "./App";
import { StoreProvider } from "./StoreContext";

// Initialize Sentry (no-op if REACT_APP_SENTRY_DSN is not set in the build env).
// CRA bakes REACT_APP_* env vars into the bundle at build time, so this must
// be set in the deploy environment BEFORE building.
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV || "development",
    release: process.env.REACT_APP_SENTRY_RELEASE,
    tracesSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 1.0,
    // Capture replay only on errors to control storage cost
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        // Replays are captured on errors only and must not carry customer data.
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Filter common noise
    ignoreErrors: [
      // Browser extensions
      "top.GLOBALS",
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications",
      // Network / cancelled requests — handled by retry logic
      "Network Error",
      "AbortError",
    ],
  });
  // eslint-disable-next-line no-console
  console.log(`[sentry] initialized for environment=${process.env.NODE_ENV}`);
}

// Rendering DOM — wrapped in Sentry.ErrorBoundary so any uncaught render
// errors are reported with full component stack trace.
ReactDOM.render(
  <Sentry.ErrorBoundary
    fallback={({ resetError }) => (
      <div style={{ padding: 40, textAlign: "center", fontFamily: "sans-serif" }}>
        <h2>Something went wrong</h2>
        <p>The error has been reported. Please try refreshing.</p>
        <button onClick={resetError} style={{ padding: "10px 20px", marginTop: 10 }}>
          Try again
        </button>
      </div>
    )}
  >
    <StoreProvider>
      <App />
    </StoreProvider>
  </Sentry.ErrorBoundary>,
  document.getElementById("root")
);
